import { render, staticRenderFns } from "./EspiralApp.vue?vue&type=template&id=5b8b1906&scoped=true"
import script from "./EspiralApp.vue?vue&type=script&lang=js"
export * from "./EspiralApp.vue?vue&type=script&lang=js"
import style0 from "./EspiralApp.vue?vue&type=style&index=0&id=5b8b1906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b1906",
  null
  
)

export default component.exports